import { createSelector } from 'reselect'
import { ShareModalConfig } from 'lib/getShareModalConfig'
import { RouteComponentProps } from 'react-router-dom'
import { parseSearchString } from 'lib/urlUtils'
import config from 'constants/config'

export const getCruiseShareModalConfig = createSelector(
  (appState: App.State) => appState.config.customerPortalURL,
  (appState: App.State) => appState.auth.account.memberId,
  (appState: App.State) => appState.router.location.pathname,
  (appState: App.State) => appState.geo.currentRegionCode,
  (appState: App.State, currentCruiseOffer: App.CruiseOffer) => currentCruiseOffer,
  (
    customerPortalURL,
    memberId,
    pathname,
    region,
    cruiseOffer,
  ): ShareModalConfig => cruiseOffer ?
      {
        customerPortalURL,
        memberId,
        offerId: cruiseOffer.ship.id,
        offerLocation: cruiseOffer.name,
        pathname,
        region,
        type: 'offer',
        utmCampaign: 'webshare',
      } :
    undefined,
)

export const injectCruiseOfferFromOrder = createSelector(
  (appState: App.State) => appState.order.order,
  (appState: App.State) => appState.order.fetching,
  (appState: App.State) => appState.cruise.cruiseOffers,
  (appState, ownProps: RouteComponentProps) => parseSearchString(ownProps.location.search)?.orderId,
  (orderFromState, orderFetching, cruiseOffers, orderId) => {
    if (orderFetching) return null

    const order = orderFromState?.id === orderId ? orderFromState : undefined

    return cruiseOffers[order?.offerId]
  },
)

export const isStandaloneCruiseEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (regionCode) => config.CRUISES_STANDLONE_ENABLED && config.STANDALONE_CRUISE_REGIONS?.split(',')?.includes(regionCode),
)
